import { VideoStreamUrlRequest } from "../store/models/camera-with-media.model";
import { Observable, EMPTY } from "rxjs";
import { DatafeedApiService } from "../../management/store/datafeeds/datafeed-api.service";
import { MapDataWorkerService } from "../../cop/web-workers/client/map-data-worker.service";
import { map } from "rxjs/operators";
import { Injectable } from "@angular/core";

@Injectable({
  providedIn: 'root'
})
export class VideoStreamService {
  constructor(
    private pipelineApiService: DatafeedApiService,
    private mapDataWorkerService: MapDataWorkerService
  ) {}

  public getVideoStreamUrl(request: VideoStreamUrlRequest): Observable<string> {
    if (request.cameraProvider === 'OpenEye Cameras') {
      return this.getOpenEyeVideoStreamUrl(request);
    }
    else if (!!request.integrationKey) {
      return this.getAgentTypeVideoStreamUrl(request);
    }
    else {
      return EMPTY;
    }
  }

  private getOpenEyeVideoStreamUrl(request: VideoStreamUrlRequest): Observable<string> {
    return this.pipelineApiService
      .getOpenEyeCameraStreamUrl(
        request.companyId,
        request.deviceId,
        request.cameraId,
        request.streamName,
        request.pipelineDefinitionUId)
      .pipe(
        map(response => {
          var content = response.content;
          if (!!content && !!request.startTime) {
            content = content.replace('time=0', 'time=' + request.startTime);
          }
          if (!!content && !!request.endTime) {
            content = content + '&etime=' + request.endTime;
          }
          return content;
        })
      )
  }

  private getAgentTypeVideoStreamUrl(request: VideoStreamUrlRequest): Observable<string> {
    this.mapDataWorkerService.sendVmsRequest(request.integrationKey, request.cameraId, null, request.startTime, request.endTime);
    return EMPTY;
  }

}
